import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bike, Store, PackageSearch } from "lucide-react";
import { api } from "@/lib/api";

export default function LocalSellers() {
  const nav = useNavigate();
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/local-sellers").then((r) => setSellers(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 py-6" data-testid="local-sellers-page">
      <div className="rounded-2xl p-5 mb-5 text-white flex items-center gap-3" style={{ background: "linear-gradient(120deg,#059669,#047857)" }}>
        <div className="w-12 h-12 bg-white/15 rounded-xl flex items-center justify-center"><Bike size={24} /></div>
        <div><h1 className="text-2xl font-extrabold">Local Delivery Sellers</h1><p className="text-emerald-50 text-sm">Aapke shehar ke premium sellers — same-area fast local delivery ke saath</p></div>
      </div>

      {loading ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">{Array.from({ length: 6 }).map((_, i) => <div key={i} className="h-28 bg-white rounded-2xl animate-pulse" />)}</div>
      ) : sellers.length === 0 ? (
        <div className="text-center py-20 text-slate-400" data-testid="no-local-sellers"><Store size={34} className="mx-auto opacity-30 mb-2" />Abhi koi premium local seller nahi hai.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {sellers.map((s) => (
            <div key={s.id} data-testid={`local-seller-${s.id}`} className="bg-white rounded-2xl border border-slate-100 p-4 hover:shadow-lg hover:border-emerald-200 transition-all">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 bg-emerald-500 rounded-xl flex items-center justify-center text-white font-extrabold">{(s.business_name || "S")[0]}</div>
                <div className="min-w-0"><p className="font-bold truncate">{s.business_name}</p><p className="text-xs text-slate-400">{s.category || "General"} · {s.product_count} products</p></div>
              </div>
              {s.local_delivery?.area && <p className="text-xs text-emerald-700 mt-2 flex items-center gap-1"><Bike size={12} /> {s.local_delivery.area} · ETA {s.local_delivery.eta_days || 1}d · ₹{s.local_delivery.charge || 0}</p>}
              <button data-testid={`view-seller-catalog-${s.id}`} onClick={() => nav(`/listing?seller_id=${s.id}`)} className="mt-3 w-full py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-bold text-sm inline-flex items-center justify-center gap-1"><PackageSearch size={15} /> View Catalog</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
